































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Conditions, OperationPickerOption, ConditionOperationType } from './../models/conditions';
import { ConditionViewModel } from './../models/conditionViewModel';
import { validationMixin } from 'vuelidate';
import { required, maxLength } from 'vuelidate/lib/validators';

const isDecimal = (value: string) => {
	const decimalRegex: RegExp = /^(\d+(\.\d{0,2})?|\.?\d{1,2})$/;
	return decimalRegex.test(value);
};

@Component({
	mixins: [validationMixin],
	validations: {
		liveCondition: {
			value: { required, isDecimal, maxLength: maxLength(25) }
		},
	}
})
export default class DecimalCondition extends Vue {
	@Prop() public condition: ConditionViewModel;

	public liveCondition: ConditionViewModel = {
		attribute: '',
		operation: '',
		type: '',
		unit: '',
		value: '',
		result: true
	};

	public operations: OperationPickerOption[] = Conditions.Operations.decimal.map((op, index) => {
		return {
			id: `${index}`,
			title: op.title,
			operation: op.operation,
			result: op.result
		};
	});

	public selectedOperationId: string = '';

	public mounted() {
		if (this.condition) {
			this.liveCondition = {
				attribute: this.condition.attribute,
				operation: this.condition.operation,
				type: this.condition.type,
				value: this.condition.value,
				result: this.condition.result,
				unit: this.condition.unit,
				invalid: this.condition.invalid
			};

			if (this.liveCondition.invalid) {
				this.$v.$touch();
			}
		}

		this.selectedOperationId = this.getSelectedOperation();
		this.operationSelected();
	}

	public destroyed() {
		this.makeFriendlyDecimal();
	}

	public getSelectedOperation() {
		if (this.liveCondition) {
			const selectedOperation = this.operations.find(op => op.operation === this.liveCondition.operation && op.result === this.liveCondition.result);
			if (selectedOperation) {
				return selectedOperation.id;
			}
		}

		return this.operations[0].id;
	}

	public operationSelected() {
		const selectedOperation = this.operations.find(op => op.id === this.selectedOperationId);
		if (selectedOperation) {
			this.liveCondition.operation = selectedOperation.operation;
			this.liveCondition.result = selectedOperation.result;
			this.emitConditionChanged();
		}
	}

	public textChanged(value: string) {
		this.liveCondition.value = value;
		this.$v.$touch();
		this.emitConditionChanged();
	}

	public get requiresInput() {
		return this.liveCondition.operation !== ConditionOperationType.IsSet;
	}

	private emitConditionChanged() {
		this.liveCondition.invalid = this.$v.$invalid && this.requiresInput;
		this.$emit('changed', this.liveCondition);
	}

	private complete() {
		this.makeFriendlyDecimal();
		this.liveCondition.invalid = this.$v.$invalid && this.requiresInput;
		this.$emit('completed', this.liveCondition);
	}

	private makeFriendlyDecimal() {
		if (!this.$v.$invalid) {
			// if it's valid, append decimal places if the input doesn't contain a . or ends in a .
			this.liveCondition.value = this.padLeadingZeroAndDecimalPlaces(this.liveCondition.value);
		}
	}

	private padLeadingZeroAndDecimalPlaces(value: string) {
		const decimalPosition = value.indexOf('.');

		if (decimalPosition === -1) {
			return value + '.00';
		}

		if (decimalPosition === 0) {
			return '0' + value;
		}

		if (decimalPosition === (value.length - 1)) {
			return value + '00';
		}

		return value;
	}
}
